module.exports = __webpack_public_path__ + "static/media/gb-eng.14167f77.svg";